import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  IDatePickerContainer,
  IDropdown,
  IToast,
  LayoutService,
  ToastService,
} from 'codex-lib';
import { Envelope } from '../../model/envelope';
import { ActivatedRoute, Params } from '@angular/router';
import { LanguageBase } from '../../model/language';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { IMyDateModel } from 'angular-mydatepicker';
import { DateTimeUtil } from 'src/app/util/date-time-util';
import { EnvelopeEditService } from '../../services/envelope-edit.service';
import { ObjectUtil } from '../../ObjectUtil';
import { EnvelopeEditTabs } from 'src/app/enum/envelope-edit-tabs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth.service';
import { SegmentAccessType } from 'src/app/enum/segment-access-type';
import { UserTypes } from 'src/app/enum/user-types';
import { EnvelopeFile } from 'src/app/main-envelope/model/envelope-file.model';
import { SentEnvelopeStatus } from 'src/app/enum/sent-envelope-status';
import { DocumentRejectedService } from 'src/app/services/document-rejected.service';
import { SignatoryEdit } from '../../model/signatory-edit';
import { CPFCNPJUtil } from 'src/app/util/CPF-CNPJ-util';
import { TableSignUserBase } from '../../model/table-sign-user-base';

@Component({
  selector: 'app-edit-envelope-information',
  templateUrl: './envelope-edit-information.component.html',
  styleUrls: ['./envelope-edit-information.component.scss'],
})
export class EnvelopeEditInformationComponent implements OnInit, OnDestroy {
  @ViewChild('confirmRemoveFileModal', { static: true })
  removeFileModalRef: TemplateRef<any>;

  envelope: Envelope;
  files: Array<EnvelopeFile> = [];
  languageBase: LanguageBase;
  languageSelected: any;
  languageEnvelopedropdown: IDropdown;
  segmentSelected: any;
  rememberOptions: IDropdown;
  reminderFrequencySelected: any;
  activeModal: NgbActiveModal;
  showModal: boolean;
  isRequiredUserSegment: boolean;
  informationAddForm: FormGroup;
  datePickerContainerModel: IMyDateModel;
  rejectToggleSelected: boolean;
  sentEnvelopeStatus = SentEnvelopeStatus;
  indexFile: number;
  signatories: any[] = [];
  tableSignUserBase: TableSignUserBase;

  datePickerContainerOptions: IDatePickerContainer = {
    icon: null,
    AngularMyDpOptions: {
      firstDayOfWeek: 'su',
      dateRange: false,
      dateFormat: 'dd/mm/yyyy',
    },
    placeholder: 'codex.datePickerComponent.datePickerPlaceholder',
    model: {
      isRange: false,
    },
  };

  segmentdropdown: IDropdown = {
    items: [],
    displayText: 'value',
    placeholder: this.translate.instant('selectAnItem'),
    clearSelectionItem: true,
    showSearch: true,
  };

  constructor(
    public layoutService: LayoutService,
    private route: ActivatedRoute,
    private envelopeEditService: EnvelopeEditService,
    private translate: TranslateService,
    private authService: AuthService,
    private modalService: NgbModal,
    private toastService: ToastService,
    private documentRejectedService: DocumentRejectedService
  ) {
    this.tableSignUserBase = new TableSignUserBase(translate);
    this.tableSignUserBase
      .createInitObject()
      .pipe(take(1))
      .subscribe((x) => x.subscribe(() => this.ngOnInit()));

    this.languageBase = new LanguageBase(translate);
    this.languageBase
      .init()
      .pipe(take(1))
      .subscribe((x) => {
        this.languageEnvelopedropdown = {
          items: this.languageBase.list(),
          displayText: 'value',
          placeholder: this.translate.instant('selectAnItem'),
          showSearch: false,
        };

        this.rememberOptions = {
          displayText: 'value',
          placeholder: this.translate.instant(
            'envelope.signatory.reminderFrequency.placeholder'
          ),
          items: [
            {
              id: 1,
              value: this.translate.instant(
                'envelope.signatory.reminderFrequency.doNotSend'
              ),
            },
            {
              id: 2,
              value: this.translate.instant(
                'envelope.signatory.reminderFrequency.EveryDay'
              ),
            },
            {
              id: 3,
              value: this.translate.instant(
                'envelope.signatory.reminderFrequency.EveryCountDay',
                { dayCount: 2 }
              ),
            },
            {
              id: 4,
              value: this.translate.instant(
                'envelope.signatory.reminderFrequency.EveryCountDay',
                { dayCount: 4 }
              ),
            },
            {
              id: 5,
              value: this.translate.instant(
                'envelope.signatory.reminderFrequency.EveryCountDay',
                { dayCount: 7 }
              ),
            },
          ],
          showSearch: false,
        };
      });

    this.informationAddForm = new FormGroup({
      id: new FormControl(null, []),
      title: new FormControl(null, [
        Validators.required,
        Validators.maxLength(500),
      ]),
      language: new FormControl(null, [Validators.required]),
      segment: new FormControl(null, [Validators.required]),
      expiration: new FormControl(null, []),
      message: new FormControl(null, []),
      reminderFrequency: new FormControl(null, []),
      isRejectable: new FormControl(null, []),
      files: new FormControl(null, []),
      filesOriginal: new FormControl(null, []),
      signatories: new FormControl(null, []),
    });

    this.datePickerContainerOptions.AngularMyDpOptions.dateFormat =
      this.languageBase.getDateFortmatByLanguageToCodex(
        this.translate.currentLang
      );
  }

  get title() {
    return this.informationAddForm.get('title');
  }

  get language() {
    return this.informationAddForm.get('language');
  }

  get segment() {
    return this.informationAddForm.get('segment');
  }

  get expiration() {
    return this.informationAddForm.get('expiration');
  }

  get message() {
    return this.informationAddForm.get('message');
  }

  get isRejectable() {
    return this.informationAddForm.get('isRejectable');
  }

  ngOnDestroy(): void {
    this.layoutService.toggleViewer(false);
  }

  ngOnInit(): void {
    const modelDataEnvelopeInformation = this.envelopeEditService.getModelData(
      EnvelopeEditTabs.Information
    );

    const modelDataEnvelopeSignatory = this.envelopeEditService.getModelData(
      EnvelopeEditTabs.Signatory
    );

    if (!ObjectUtil.isEmpty(modelDataEnvelopeInformation)) {
      this.informationAddForm = modelDataEnvelopeInformation;

      if (!ObjectUtil.isEmpty(modelDataEnvelopeSignatory)) {
        const currentSignatories =
          this.informationAddForm.get('signatories').value;
        const filteredSignatories = currentSignatories.filter((signatory) =>
          modelDataEnvelopeSignatory.signatories.some(
            (item) => item.id === signatory.id
          )
        );
        this.informationAddForm
          .get('signatories')
          .setValue(modelDataEnvelopeSignatory.signatories);
      }

      this.validFilesRejecteds(
        this.informationAddForm.value.files,
        modelDataEnvelopeSignatory.signatories
      );
    }

    this.envelopeEditService.getSegmentsItems().subscribe((items) => {
      this.segmentdropdown = {
        items,
        displayText: 'value',
        placeholder:
          items.length > 0
            ? this.translate.instant('selectAnItem')
            : this.translate.instant(
                'settings.segment.modalAdd.noSegmentFounded'
              ),
        clearSelectionItem: true,
        showSearch: true,
      };

      if (ObjectUtil.isEmpty(modelDataEnvelopeInformation)) {
        this.route.params.subscribe((params: Params) => {
          this.envelopeEditService
            .getEnvelope(params['envelopeId'])
            .subscribe((envelope) => {
              this.envelope = envelope;
              this.files = Object.assign([], this.envelope.files);
              const filesOriginals = this.files;
              this.validFilesRejecteds(this.files, this.envelope.signatories);
              this.setValueSignatories();
              this.rejectToggleSelected = this.envelope.isRejectable;

              this.informationAddForm.patchValue({
                id: this.envelope.id,
                title: this.envelope.title,
                segment: this.envelope.segment,
                expiration: this.envelope.expiration,
                reminderFrequency: this.rememberOptions.items.find(
                  (x) => x.id === this.envelope.reminderFrequency
                ),
                message: this.envelope.message,
                language: this.languageBase
                  .list()
                  .find((x) => x.id === this.envelope.language),
                isRejectable: this.envelope.isRejectable,
                files: this.envelope.files,
                filesOriginal: filesOriginals,
                signatories: this.envelope.signatories,
              });

              this.envelopeEditService.setModelData(
                this.informationAddForm,
                EnvelopeEditTabs.Information
              );
              this.setFormValues();
              this.layoutService.toggleLoading(false);
            });
        });
      } else {
        this.setModalDataFormValues();
      }

      this.authService.authModel.subscribe((authModel) => {
        this.isRequiredUserSegment =
          authModel.signUser.segmentAccessType ===
            SegmentAccessType.FULL_ACCESS ||
          authModel.signUser.type === UserTypes.Admin
            ? false
            : true;

        if (!this.isRequiredUserSegment) {
          this.informationAddForm.get('segment').clearValidators();
          this.informationAddForm.get('segment').updateValueAndValidity();
        }
        this.showModal = this.isRequiredUserSegment;
      });
    });
  }

  validFilesRejecteds(files: EnvelopeFile[], signatories) {
    this.files = files.filter((file) => {
      const correspondingSignatory = signatories
        ?.filter((y) => !y.reuseSignatures && y.envelopeSignatoryId > 0)
        .find((signatory) =>
          file?.envelopeRejectedHistory.some(
            (history) => history.signatoryId === signatory.id
          )
        );
      if (correspondingSignatory) {
        return correspondingSignatory.status === 3;
      }
      return true;
    });
  }

  validFileRejected(file: EnvelopeFile) {
    const correspondingSignatory = this.informationAddForm.value.signatories
      .filter((y) => !y.reuseSignatures && y.envelopeSignatoryId > 0)
      .find((signatory) =>
        file.envelopeRejectedHistory.some(
          (history) => history.signatoryId === signatory.id
        )
      );
    if (correspondingSignatory) {
      return true;
    }
    return false;
  }

  setFormValues() {
    if (this.informationAddForm.value['language']) {
      this.languageSelected = this.informationAddForm.value['language'];
    }

    this.onLanguageSelectItem(this.languageSelected);
    this.setDateExpirationEnvelope(this.informationAddForm.value['expiration']);
    this.setSegmentEnvelope(this.informationAddForm.value['segment']);

    if (this.informationAddForm.value['reminderFrequency']) {
      this.reminderFrequencySelected =
        this.informationAddForm.value['reminderFrequency'];
    }
  }

  setModalDataFormValues() {
    if (this.informationAddForm.value['language']) {
      this.languageSelected = this.informationAddForm.value['language'];
    }

    this.onLanguageSelectItem(this.languageSelected);
    this.onExpirationSelectItem(this.informationAddForm.value['expiration']);

    if (this.informationAddForm.value['segment']) {
      this.segmentSelected = this.informationAddForm.value['segment'];
    }

    this.onSegmentSelectItem(this.informationAddForm.value['segment']);

    if (this.informationAddForm.value['reminderFrequency']) {
      this.reminderFrequencySelected =
        this.informationAddForm.value['reminderFrequency'];
    }

    this.envelope = this.envelopeEditService.Envelope;
    this.files = Object.assign(this.informationAddForm.value.files);
    this.rejectToggleSelected = this.envelope.isRejectable;
  }

  setDateExpirationEnvelope(dateExpiration) {
    if (dateExpiration != null) {
      const date = new Date(dateExpiration);
      this.datePickerContainerModel = {
        isRange: false,
        singleDate: {
          date: {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate(),
          },
          formatted:
            date.getDate() +
            '/' +
            (date.getMonth() + 1) +
            '/' +
            date.getFullYear(),
          jsDate: date,
        },
      };
    }
  }

  setSegmentEnvelope(segment) {
    if (segment != null) {
      this.segmentSelected = this.segmentdropdown.items.find(
        (x) => x.id === segment.id
      );
      this.segment.setValue(segment);
      this.onSegmentSelectItem(this.segmentSelected);
    }
  }

  onExpirationSelectItem(value: IMyDateModel) {
    this.informationAddForm.get('expiration').setValue(value);
    this.datePickerContainerModel = value;

    if (
      value == null ||
      value === undefined ||
      value.singleDate == null ||
      value.singleDate === undefined ||
      value.singleDate.jsDate === null
    ) {
      const expirationControl = this.informationAddForm.get('expiration');
      expirationControl.clearAsyncValidators();
      expirationControl.clearValidators();
      expirationControl.updateValueAndValidity({ emitEvent: false });
      return;
    }

    if (value.singleDate.epoc < DateTimeUtil.getCurrentTimestamp()) {
      this.informationAddForm
        .get('expiration')
        .setErrors({ dateInvalid: true });
        return;
    }
  }

  onLanguageSelectItem(value) {
    this.informationAddForm.get('language').setValue(value);
  }

  onSegmentSelectItem(value) {
    this.informationAddForm.get('segment').setValue(value);
  }

  onSelectFrequency(value) {
    this.informationAddForm.get('reminderFrequency').setValue(value);
  }

  showModalSegment(segmentModalContent) {
    if (this.segmentdropdown.items.length < 1 && this.showModal) {
      this.activeModal = this.modalService.open(segmentModalContent);
    }
  }

  confirmModalClose() {
    this.activeModal.dismiss();
  }

  confirmModalYesClick() {
    this.activeModal.close();
  }

  confirmRemoveFileClick() {
    this.files.splice(this.indexFile, 1);
    this.activeModal.close();

    this.documentRejectedService.setIsRemoveDocumentRejected(true);
    this.documentRejectedService.verifyIsRemoveDocumentRejected(
      this.signatories
    );

    const signatoriesToEdit = this.envelopeEditService.getModelData(
      EnvelopeEditTabs.Signatory
    ) as Array<SignatoryEdit>;

    this.envelopeEditService.setModelData(
      signatoriesToEdit.length === 0 ? this.signatories : signatoriesToEdit,
      EnvelopeEditTabs.Signatory
    );

    this.informationAddForm.get('files').setValue(this.files);
    this.envelopeEditService.setModelData(
      this.informationAddForm,
      EnvelopeEditTabs.Information
    );

    const toastDeleteFile: IToast = {
      text: this.translate.instant('envelope-edit.deleteFileSuccess'),
      autoHide: true,
      type: 'success',
    };
    this.toastService.createNewToast(toastDeleteFile);
  }

  setValueSignatories() {
    this.route.params.subscribe((params: Params) => {
      this.envelopeEditService
        .getEnvelope(params['envelopeId'])
        .subscribe((envelope) => {
          envelope.signatories.forEach((x) => {
            const alreadyExists = this.signatories.some(
              (signatory) => signatory.id === x.id
            );
            if (!alreadyExists) {
              const signatory = new SignatoryEdit();
              signatory.id = x.id;
              signatory.order = x.order;
              signatory.name = x.name;
              signatory.mail = x.mail;
              signatory.ssn = x.ssn;
              signatory.phoneNumber = x.phoneNumber;
              signatory.acceptWhatsApp = x.acceptWhatsApp;
              signatory.sendWhatsApp = x.sendWhatsApp;
              signatory.ssnWithMask = CPFCNPJUtil.formatSsn(x.ssn);
              signatory.signatureTypeValue = this.onSignatureType(
                x.signatureType
              );
              signatory.subscriberTypeValue = this.onSubscriberType(
                x.subscriberType
              );
              signatory.status = x.status;
              signatory.signatureTypeSelectedValue = x.signatureTypeSelected
                ? this.onSignatureType(x.signatureTypeSelected)
                : '';
              signatory.checked = false;
              signatory.signatureType = x.signatureType;
              signatory.subscriberType = x.subscriberType;
              signatory.envelopeSignatoryId = x.envelopeSignatoryId;
              this.signatories.push(signatory);
            }
          });
        });
    });
  }

  onSubscriberType(id: number) {
    return this.tableSignUserBase.subscriberType.GetValue(id);
  }

onSignatureType(id: number) {
    return this.tableSignUserBase.signatureType.GetValue(id);
  }

  setReplaceTitle() {
    let titleEnvelope = this.informationAddForm.get('title').value;
    // Verifique se titleEnvelope é uma string antes de chamar replace
    if (typeof titleEnvelope === 'string') {
      // Substitua os caracteres desejados
      titleEnvelope = titleEnvelope.replace(/[;=]/g, '').trim();
      this.informationAddForm.get('title').setValue(titleEnvelope);
    }
  }

  removeFile(indexFile) {
    if (this.files.length === 1) {
      const toastFile: IToast = {
        text: this.translate.instant('envelope-edit.deleteLastFile'),
        autoHide: true,
        type: 'danger',
      };
      this.toastService.createNewToast(toastFile);
      return;
    }
    this.indexFile = indexFile;
    this.activeModal = this.modalService.open(this.removeFileModalRef);
  }

  onRejectToggle(value: boolean, isUserAction?: boolean) {
    this.informationAddForm.get('isRejectable').setValue(value);
    this.rejectToggleSelected = value;
  }

  restoreFiles() {
    this.files = Object.assign(
      [],
      this.informationAddForm.get('filesOriginal').value
    );
    this.informationAddForm.get('files').setValue(this.files);
    this.documentRejectedService.setIsRemoveDocumentRejected(true);
    this.documentRejectedService.verifyIsRemoveDocumentRejected(
      this.signatories
    );
  }
}
